import { getCurrentDateTimeFilenameSuffix, isolateFilename, removeDateSuffix } from 'shared-utils/file';
import { DataExtension, SetupExtension } from 'shared-utils/file-system';

import { DpuFileType } from '../dpu-file.type';

export const getAutoNamingFileName = (currentFileName: string | undefined, fileType: DpuFileType): string => {
  const fileNameWithoutDateSuffix: string = currentFileName
    ? removeDateSuffix(isolateFilename(currentFileName))
    : 'newFile';

  const newDateSuffix: string = getCurrentDateTimeFilenameSuffix();
  const extension: SetupExtension | DataExtension = fileType === 'data' ? '.nde' : '.uset';

  return `${fileNameWithoutDateSuffix}${newDateSuffix}${extension}`;
};
